import styled from "styled-components";

export const SectionContainer = styled.div`
  margin-top: 30px;
  z-index: 1 !important;
  width: 100%;
  margin-bottom: 60px;
`;

export const SectionWrap = styled.div`
	width: 100%;
	background-color: transparent;
	display: flex;
	align-self: center;
	justify-content: center;
	align-items: center;
`

export const MarketTableSection = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`
